import { useCallback } from 'react';
import useGlobalModal from 'hooks/useGlobalModal';
import * as track from 'lib/gaTracking/crossPageEvents';
import { downloadAppleWalletPassErrorModalProps } from './DownloadAppleWalletPassErrorModal';

export const useDownloadAppleWalletPassErrorModal = () => {
  const { showModal } = useGlobalModal();

  return useCallback(() => {
    track.appleWalletPassDownloadFailedModalOpened();
    showModal({
      ...downloadAppleWalletPassErrorModalProps,
      onClose: ({ actionButtonClicked }) => {
        track.appleWalletPassDownloadFailedModalClosed(actionButtonClicked);
      },
    });
  }, [showModal]);
};
